
import { supabase } from "@/integrations/supabase/client";

const normalizeEmail = (email: string) => email.trim().toLowerCase();

const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 255;

export const loginWithPassword = async (
  email: string,
  password: string
): Promise<boolean> => {
  try {
    const normalized = normalizeEmail(email);
    if (!isValidEmail(normalized) || !password) {
      return false;
    }

    const { error } = await supabase.auth.signInWithPassword({
      email: normalized,
      password,
    });

    if (error) {
      console.error("Login failed");
      return false;
    }
    return true;
  } catch (error) {
    console.error("Unexpected error during login");
    return false;
  }
};

export const requestPasswordReset = async (email: string): Promise<boolean> => {
  try {
    const normalized = normalizeEmail(email ?? "");
    if (!isValidEmail(normalized)) {
      return false;
    }

    // The reset token is generated and stored server-side; the client only
    // receives it through the emailed link.
    const response = await supabase.functions.invoke("send-password-reset", {
      body: { email: normalized },
    });

    if (response.error) {
      console.error("Password reset request failed");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error requesting password reset");
    return false;
  }
};

export const resetPassword = async (
  token: string,
  newPassword: string
): Promise<boolean> => {
  try {
    if (!token || !newPassword) {
      return false;
    }

    // The token is validated server-side against the stored reset token.
    const { error } = await supabase.functions.invoke("admin-reset-password", {
      body: {
        newPassword,
        resetToken: token,
      },
    });

    if (error) {
      console.error("Password reset rejected");
      return false;
    }

    return true;
  } catch (error) {
    console.error("Unexpected error during password reset");
    return false;
  }
};
